/**
 * Grilla de tarjetas responsive. `renderCard(item)` define el contenido de cada tarjeta.
 */
const CardGrid = ({
    items,
    renderCard,
    loading,
    error,
    emptyMessage = 'No hay registros.',
    columns = 'repeat(auto-fill, minmax(240px, 1fr))',
}) => {
    if (loading) return <div className="sp-card"><p>Cargando...</p></div>;
    if (error) return <div className="sp-card sp-card--danger"><p>{error}</p></div>;
    if (!items.length) return <div className="sp-card"><p>{emptyMessage}</p></div>;

    return (
        <div style={{ display: 'grid', gridTemplateColumns: columns, gap: '1rem' }}>
            {items.map((item, idx) => (
                <div key={item.id ?? idx}>{renderCard(item)}</div>
            ))}
        </div>
    );
};

export default CardGrid;